import { createContext, useContext } from "react";
import type { TeamMemberRole } from "../types";

export type Permissions = {
  role: TeamMemberRole;
  canManage: boolean;
  canManageMembers: boolean;
  isAppAdmin: boolean;
  isSuperAdmin: boolean;
};

export const PermissionsContext = createContext<Permissions>({
  role: "player",
  canManage: false,
  canManageMembers: false,
  isAppAdmin: false,
  isSuperAdmin: false,
});

export function usePermissions() {
  return useContext(PermissionsContext);
}
